import {
	AvatarSize, MiddleEllipsisWhisper, cn, Avatar, AvatarEntity,
} from '@aleph/shared-components';

interface IProps {
	onClick?: () => void
	name: string
	classname?: string
	entityType?: AvatarEntity
	avatarSource?: string
	entityUserInitials?: string
}

function EntityName({
	onClick, name, classname = '', entityType, avatarSource, entityUserInitials,
}: IProps) {
	const className = cn(
		`flex flex-1 items-center px-[5px] gap-[14px] group overflow-hidden text-[16px]
		font-medium text-gray-950`,
		{
			'cursor-pointer hover:text-blue focus:text-blue focus:outline-none': onClick,
			'pointer-events-none cursor-default':                                !onClick,
		},
		classname,
	);

	return (
		<button
			onClick={onClick}
			className={className}
		>
			<Avatar
				src={avatarSource}
				size={AvatarSize.M}
				entityType={entityType}
				entityUserInitials={entityUserInitials}
			/>
			<div className="overflow-hidden w-full text-left">
				<MiddleEllipsisWhisper value={name} />
			</div>
		</button>
	);
}

export default EntityName;
